<template>
    <div>
        <b-navbar toggleable type="dark" fixed="top">
            <b-navbar-brand>
                <b-img :src="logoUrl"></b-img>
            </b-navbar-brand>
            
            <b-navbar-toggle target="navbar-toggle-collapse">
                <template #default="{ expanded }">
                    <i v-if="expanded" class="fa-solid fa-ellipsis-vertical icon-default"></i>
                    <i v-else class="fa-solid fa-ellipsis-vertical icon-selected"></i>
                </template>
            </b-navbar-toggle>

            <b-collapse id="navbar-toggle-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item 
                        v-for="(item, index) in navItemsBottom" 
                        :active="isActive(item)" 
                        exact 
                        exact-active-class="active" 
                        :key="index" 
                        @click="handleNavItemClick(item)"
                    >
                        <b-row>
                            <b-col cols="1">
                                <i :class="item.icon" class="fa-2x"></i>        
                            </b-col>
                            <b-col cols="10">
                                <p>{{ item.label }}</p>
                            </b-col>
                        </b-row>                        
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <b-navbar v-if="!isSeller" type="dark" fixed="bottom" class="justify-content-center">
            <b-nav-item 
                v-for="(navItem, index) in navigationItems" 
                :key="index" 
                :active="isActive(navItem)" 
                exact 
                exact-active-class="active"
                @click="handleNavItemClick(navItem)"
                class="d-flex justify-content-center"
                
            >
                <div v-if="isActive(navItem)" :style="{ backgroundImage: `url(${require('@assets/images/v3/nav-bkgrd-eclipse.png')}` }">
                    <i :class="isActive(navItem) ? navItem.icon + ' fa-3x' : navItem.icon + ' fa-2x'" />
                </div>                
                <i v-else :class="isActive(navItem) ? navItem.icon + ' fa-3x' : navItem.icon + ' fa-2x'" />
                
            </b-nav-item>
        </b-navbar>
    </div>
</template>

<script>
import './NavBar.scss';

export default {
    name: 'NavBar',
    props:{
        navigationItems: {
            type: Array
        },
        activeItems:{
            type: Array
        },
        position:{
            default: 'top'
        },
        isSeller: {
            type: Boolean,
            default: false
        },
    },
    mixins: [
    ],
    components: {
    },
    data: () => ({
        bgVariant: 'dark'
    }),
    computed: {
        logoUrl(){
            return require('@assets/images/v3/SS Wordmark-White 1.svg');
        },
        navItemsBottom(){
            const help = {
                name:'Help',
                icon: 'fa-solid fa-comment-question',
                label: this.isBrokerOwner ? 'Support' : 'Support',
                popover: this.isBrokerOwner ? 'Support' : 'Support',
                action: 'help',
            };

            const logout = {
                name: 'Logout',
                icon: 'fa-solid fa-x',
                label: this.isBrokerOwner ? 'Logout' : 'Logout',
                popover: this.isBrokerOwner ? 'Logout' : 'Logout',
                action: 'sign-out',
            }
            if(this.isSeller){
                return this.navigationItems;
            }
            else{    
                return [
                    help,
                    logout
                ];
            }
            
        },
    },
    methods: {
        isActive(item){
            if (Array.isArray(this.activeItems)) {
                if(item.label=="Support"){
                    const found = this.activeItems.some(el => 
                        el.icon === item.icon &&
                        el.label === item.label &&
                        el.popover === item.popover &&
                        el.action === item.action
                    );
                    return found
                }
                return this.activeItems.includes(item);
            }
            return isEqual(this.activeItems, item);
        },
        handleNavItemClick(item){
            this.$emit('click', item);
        }
    }
}
</script>
